"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuscleOICarousel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../../hooks");
const ModeCarousel_1 = require("../ModeCarousel");
function MuscleOICarousel() {
    const tabContent = (0, hooks_1.useTabContent)(bridge_schema_1.InfoBoxTabType.MuscleOI);
    const { items = [] } = tabContent;
    return (0, jsx_runtime_1.jsx)(ModeCarousel_1.ModeCarousel, { type: bridge_schema_1.InfoBoxTabType.MuscleOI, "data-e2e": 'MuscleOICarousel_ModeCarousel', children: items });
}
exports.MuscleOICarousel = MuscleOICarousel;
